<div class="user-indicator">
  <button #userButton
          [matMenuTriggerFor]="userMenu" class="user-indicator user-menu-trigger">{{ userName }}
    <mat-icon>account_circle</mat-icon>
  </button>
  <mat-menu #userMenu="matMenu" [appTutorialTarget]="'userMenu'">
    <app-user-menu (click)="$event.stopPropagation()"></app-user-menu>
  </mat-menu>
</div>
